import { Tags } from '@ppvrbh/merchant-frontend-core';
import { CatState } from './cat-reducer';
import { CAT_ACTION_TYPE, CatActions, SortMenuSequenceAction } from './cat-type';
import { MenuCategoryData } from '../interface';
import { MenuInCatType } from '../../../../shared/models/food-menu';

export const catCreators = {
  setCatState: <KeyName extends keyof CatState>(key: KeyName, value: CatState[KeyName])
    : CatActions => ({
      type: CAT_ACTION_TYPE.SET_CAT_STATE,
      payload: { key, value }
    }),
  callFoodCategory: (
    onFailureCallback: () => void,
    isAddCategoryPage: boolean,
    onSuccessCallback?: (tagMaster: Tags[]) => void,
    options?: {menuCount?: boolean, menuCategoryCount ?: boolean, keyword?: string, page?: number, limit?: number}
  ) => ({
    type: CAT_ACTION_TYPE.CALL_FOOD_CATEGORY,
    payload: { onFailureCallback, isAddCategoryPage, onSuccessCallback, options }
  }),
  callFullFoodCategory: (onSuccessCallback: (menuCategories: MenuCategoryData[]) => void) => ({
    type: CAT_ACTION_TYPE.CALL_FULL_FOOD_CATEGORY,
    payload: {onSuccessCallback}
  }),
  updateCategorySequence: () => ({
    type: CAT_ACTION_TYPE.SET_CATEGORY_SEQUENCE,
  }),
  callMenuInCat: (
    onFailureCallback: () => void,
    foodCategoryId: string,
    onSuccessCallback?: (menuInCat: MenuInCatType) => void,
    options?: { search?: string; page?: number; limit?: number }
  ) => ({
    type: CAT_ACTION_TYPE.CALL_MENU_IN_CAT,
    payload: { onFailureCallback, foodCategoryId, onSuccessCallback, ...options }
  }),
  sortMenuSequence: (
    menuCategoryId: number,
    menuIds: number[],
    onSuccessCallback?: () => void,
    onFailureCallback?: () => void,
  ): SortMenuSequenceAction => ({
    type: CAT_ACTION_TYPE.SORT_MENU_SEQUENCE,
    payload: { menuCategoryId, menuIds, onSuccessCallback, onFailureCallback },
  }),
};
